/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_License_Plate_RequiredInputs */

const en_case_validation_license_plate_required = /** @type {(inputs: Case_Validation_License_Plate_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License plate is required.`)
};

const pt_br2_case_validation_license_plate_required = /** @type {(inputs: Case_Validation_License_Plate_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placa é obrigatória.`)
};

/**
* | output |
* | --- |
* | "License plate is required." |
*
* @param {Case_Validation_License_Plate_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_license_plate_required = /** @type {((inputs?: Case_Validation_License_Plate_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_License_Plate_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_license_plate_required(inputs)
	return pt_br2_case_validation_license_plate_required(inputs)
});